import golden from "../../../../fixtures/template_version.golden.json";
import catalogSeed from "../../../../catalog/catalog.json";
import type { CatalogEntry, TemplateVersion } from "./types";

export const goldenVersion = golden as unknown as TemplateVersion;
export const catalogEntries = (catalogSeed as { entries: CatalogEntry[] }).entries;
